export {
  VscodeContextMenuItem,
  VscClickEventDetail,
} from './vscode-context-menu-item.js';
